import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const laPaz = [
  { date: "April 5", hour: "8:00", availability: "Avalilable" },
  { date: "April 5", hour: "11:00", availability: "Sold Out" },
  { date: "April 9", hour: "11:00", availability: "Sold Out" },
  { date: "April 19", hour: "08:00", availability: "Sold Out" },
  { date: "April 26", hour: "08:00", availability: "Sold Out" },
  { date: "May 3", hour: "08:00", availability: "Avalilable" },
  { date: "May 7", hour: "08:00", availability: "Sold Out" },
  { date: "May 28", hour: "11:00", availability: "Sold Out" },
  { date: "June 4", hour: "08:00", availability: "Avalilable" },
  { date: "June 4", hour: "11:00", availability: "Avalilable" },
  { date: "June 7", hour: "08:00", availability: "Avalilable" },
  { date: "June 14", hour: "08:00", availability: "Avalilable" },
  { date: "June 14", hour: "11:00", availability: "Avalilable" },
  { date: "June 18", hour: "08:00", availability: "Avalilable" },
  { date: "June 21", hour: "11:00", availability: "Avalilable" },
  { date: "June 28", hour: "08:00", availability: "Avalilable" },
  { date: "July 2", hour: "08:00", availability: "Avalilable" },
  { date: "July 2", hour: "11:00", availability: "Avalilable" },
  { date: "July 5", hour: "08:00", availability: "Avalilable" },
  { date: "July 9", hour: "08:00", availability: "Avalilable" },
  { date: "July 19", hour: "08:00", availability: "Avalilable" },
  { date: "July 19", hour: "11:00", availability: "Avalilable" },
  { date: "August 1", hour: "08:00", availability: "Avalilable" },
  { date: "August 1", hour: "11:00", availability: "Sold Out" },
  { date: "August 6", hour: "08:00", availability: "Avalilable" },
  { date: "August 14", hour: "08:00", availability: "Sold Out" },
  { date: "August 23", hour: "08:00", availability: "Avalilable" },
];

const santaCruz = [
  { date: "April 5", hour: "8:00", availability: "Sold Out" },
  { date: "April 5", hour: "11:00", availability: "Sold Out" },
  { date: "April 9", hour: "11:00", availability: "Sold Out" },
  { date: "April 19", hour: "08:00", availability: "Sold Out" },
  { date: "April 26", hour: "08:00", availability: "Sold Out" },
  { date: "May 3", hour: "08:00", availability: "Sold Out" },
  { date: "May 17", hour: "08:00", availability: "Avalilable" },
  { date: "May 25", hour: "11:00", availability: "Sold Out" },
  { date: "June 4", hour: "08:00", availability: "Sold Out" },
  { date: "June 4", hour: "11:00", availability: "Sold Out" },
  { date: "June 7", hour: "08:00", availability: "Sold Out" },
  { date: "June 14", hour: "08:00", availability: "Sold Out" },
  { date: "June 14", hour: "11:00", availability: "Sold Out" },
  { date: "June 18", hour: "08:00", availability: "Sold Out" },
  { date: "June 21", hour: "11:00", availability: "Sold Out" },
  { date: "June 28", hour: "08:00", availability: "Sold Out" },
  { date: "July 2", hour: "08:00", availability: "Sold Out" },
  { date: "July 5", hour: "08:00", availability: "Avalilable" },
  { date: "July 16", hour: "03:00", availability: "Sold Out" },
  { date: "August 2", hour: "08:00", availability: "Avalilable" },
  { date: "August 2", hour: "03:00", availability: "Avalilable" },
  { date: "August 6", hour: "08:00", availability: "Sold Out" },
  { date: "August 14", hour: "08:00", availability: "Sold Out" },
  { date: "August 28", hour: "08:00", availability: "Sold Out" },
];

const cochabamba = [
  { date: "April 5", hour: "8:30", availability: "Avalilable" },
  { date: "April 4", hour: "11:30", availability: "Sold Out" },
  { date: "April 9", hour: "8:30", availability: "Sold Out" },
  { date: "April 12", hour: "8:30", availability: "Avalilable" },
  { date: "April 26", hour: "11:30", availability: "Sold Out" },
  { date: "May 3", hour: "08:30", availability: "Avalilable" },
  { date: "May 7", hour: "08:30", availability: "Sold Out" },
  { date: "May 28", hour: "11:30", availability: "Sold Out" },
  { date: "June 4", hour: "08:30", availability: "Avalilable" },
  { date: "June 4", hour: "11:30", availability: "Sold Out" },
  { date: "June 7", hour: "08:00", availability: "Sold Out" },
  { date: "June 14", hour: "08:30", availability: "Sold Out" },
  { date: "June 14", hour: "11:30", availability: "Sold Out" },
  { date: "June 18", hour: "08:30", availability: "Avalilable" },
  { date: "July 2", hour: "08:00", availability: "Avalilable" },
  { date: "July 2", hour: "11:00", availability: "Sold Out" },
  { date: "July 5", hour: "08:00", availability: "Sold Out" },
  { date: "July 9", hour: "08:00", availability: "Sold Out" },
  { date: "July 12", hour: "08:00", availability: "Sold Out" },
  { date: "July 12", hour: "11:00", availability: "Sold Out" },
  { date: "August 1", hour: "08:00", availability: "Avalilable" },
  { date: "August 1", hour: "11:00", availability: "Sold Out" },
  { date: "August 6", hour: "08:00", availability: "Avalilable" },
  { date: "August 14", hour: "08:00", availability: "Sold Out" },
  { date: "August 23", hour: "08:00", availability: "Avalilable" },
  { date: "August 23", hour: "08:00", availability: "Avalilable" },
];

const Test = () => {
  return (
    <div>
      <Box sx={{ padding: "15px 0 15px 0" }}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ background: "#009999" }}
          >
            <Typography
              variant="h6"
              align="center"
              sx={{ background: "#009999", color: "#fff", width: "100%" }}
            >
              <b>LA PAZ</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <b>DATE</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>HOUR</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>AVAILABILITY</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {laPaz.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color:
                            row.availability === "Sold Out" ? "red" : "#000",
                        }}
                      >
                        {row.availability}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box sx={{ padding: "15px 0 15px 0" }}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ background: "#009999" }}
          >
            <Typography
              variant="h6"
              align="center"
              sx={{ background: "#009999", color: "#fff", width: "100%" }}
            >
              <b>SANTA CRUZ</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <b>DATE</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>HOUR</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>AVAILABILITY</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {santaCruz.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color:
                            row.availability === "Sold Out" ? "red" : "#000",
                        }}
                      >
                        {row.availability}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box sx={{ padding: "15px 0 15px 0" }}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ background: "#009999" }}
          >
            <Typography
              variant="h6"
              align="center"
              sx={{ background: "#009999", color: "#fff", width: "100%" }}
            >
              <b>COCHABAMBA</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <b>DATE</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>HOUR</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>AVAILABILITY</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cochabamba.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color:
                            row.availability === "Sold Out" ? "red" : "#000",
                        }}
                      >
                        {row.availability}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};

export default Test;
